<template>
  <header id="header">
    <img class="logo" src="/assets/logo.svg" width="180" height="37">
    <a href="/" class="btn-back" v-if="back" @click.prevent="goBack">Back</a>
  </header>
</template>

<script>
export default {
  props: ['back'],
  methods: {
    goBack () {
      this.$router.push({ name: this.back })
    }
  }
}
</script>

<style lang="scss">
  #header{
    position: absolute;
    z-index: 2;
    top: $min-nav-height + 10;
    transition: left $ui-transition ease;
    .logo{
        display: none;
    }
  }
</style>
